module.exports = __webpack_public_path__ + "img/19.f6f11852.png";